import styled from "styled-components";

export const BtnContainer = styled.div`
    position:relative;
    z-index: 4000;
    display:flex;
    flex-direction:row;
    align-items:center;

    span {
        margin-right: 10px;
    }

`;